<template>
  <p v-if="fomoMessaging.length > 0" class="ProductForm__Fomo">
    {{ fomoMessaging }}
  </p>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const fomoMessaging = ref('');

const getFomo = () => {
  const element = document.querySelector('.fomo-inline');
  fomoMessaging.value = element.textContent.length > 0 ? element.textContent : '';
};

onMounted(() => {
  /*
   * Fomo is an external vendor that injects content into an element, but the
   * element must exist outside of the Vue app. We've inserted the element
   * outside of the main-product component, give it display: none, then we get
   * it's content from within the Vue app. This keeps them independent from one
   * another, and the Vue app simply reads from it onMount and via an observer.
   */
  getFomo();
  const fomoEl = document.querySelector('.fomo-inline');
  const fomoObserverConfig = {
    attributes: true,
    childList: true,
    subtree: true,
  };
  const fomoObserver = new MutationObserver(getFomo);
  fomoObserver.observe(fomoEl, fomoObserverConfig);
});
</script>
